import * as React from "react";
import TanStackTableWrapper from "../../../../components/Table/Migration/TanStackTableWrapper";
import * as _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { editActions } from "../../../../actions/editActions";
import { searchMatchRule } from "../../../../utils/utils";
import styles from "./EventTypeSections.module.scss";
import trash from "../../../../images/trash.svg";

export type TableProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rows: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isRowSelected: (row: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleRowSelection: (row: any) => void;
  columnType?: string;
  filterable?: boolean;
  tableHeight?: string;
};

const EventTypeSections: React.FC<TableProps> = ({ rows, isRowSelected, handleRowSelection, columnType, filterable = false, tableHeight }) => {
  const dispatch = useDispatch();
  const boundEditActions = bindActionCreators(editActions, dispatch);
  const columns: State.ColumnMap = useSelector((state: State.Root) => state.columns);
  const editedEnumeration: Api.MessageType = useSelector((state: State.Root) => state.editView.editedObject);

  const selectedColumns: State.Column[] = columns[columnType as keyof State.ColumnMap];

  return (
    <div className={styles.container}>
      <TanStackTableWrapper
        filterable={filterable}
        setHeight={tableHeight}
        pageSize={rows.length as any}
        disablePagination={true}
        showPageSizeOptions={false}
        showPagination={false}
        defaultFilterMethod={(filter, row) =>
          searchMatchRule(String(row[filter.id]), filter.value)
        }
        rows={rows}
        minRows={0}
        isHidingTextActive={false}
        handleRowSelection={handleRowSelection}
        isRowSelected={isRowSelected as any}
        columns={
          (columnType === "Message Type Event Types"
            ? selectedColumns
            : [
                ...selectedColumns,
                {
                  Header: "",
                  id: "removeIcon",
                  accessor: "showRemove",
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  Cell: (props: any) => (
                    <span className={styles.remove}>
                      <img
                        className={styles.removeIcon}
                        src={trash}
                        alt="Remove"
                        onClick={(e) => {
                          e.stopPropagation();
                          boundEditActions.setEdited({
                            ...editedEnumeration,
                            mapping: {
                              ...(editedEnumeration.mapping ?? { eventClass: null }),
                              eventTypes: _.filter(
                                editedEnumeration.mapping?.eventTypes ?? [],
                                item => item.enumValue !== props.original.enumValue
                              )
                            }
                          });
                        }}
                      />
                    </span>
                  ),
                  width: 48,
                  minWidth: 30,
                  filterable: false
                }
              ]) as any
        }
        style={{ display: "flex", flex: 1 }}
        className="-striped -highlight data-sections"
      />
    </div>
  );
};

export default EventTypeSections;

